/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class V3RTBCampaign {
    'id'?: string;
    'externalId'?: string;
    'name'?: string;
    'advertiser'?: string;
    'excludedNetworkIds'?: Array<string>;
    'daypartSchedule'?: Array<number>;
    'daypartTimezone'?: string;
    'status'?: string;
    'currency'?: string;
    'pacingStrategy'?: string;
    'budget'?: number;
    'dailyBudget'?: number;
    'startTime'?: string;
    'endTime'?: string;
    'baseCpm'?: number;
    'minCpm'?: number;
    'maxCpm'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "externalId",
            "baseName": "externalId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "advertiser",
            "baseName": "advertiser",
            "type": "string",
            "format": ""
        },
        {
            "name": "excludedNetworkIds",
            "baseName": "excludedNetworkIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "daypartSchedule",
            "baseName": "daypartSchedule",
            "type": "Array<number>",
            "format": "int32"
        },
        {
            "name": "daypartTimezone",
            "baseName": "daypartTimezone",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "currency",
            "baseName": "currency",
            "type": "string",
            "format": ""
        },
        {
            "name": "pacingStrategy",
            "baseName": "pacingStrategy",
            "type": "string",
            "format": ""
        },
        {
            "name": "budget",
            "baseName": "budget",
            "type": "number",
            "format": "double"
        },
        {
            "name": "dailyBudget",
            "baseName": "dailyBudget",
            "type": "number",
            "format": "double"
        },
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "string",
            "format": ""
        },
        {
            "name": "endTime",
            "baseName": "endTime",
            "type": "string",
            "format": ""
        },
        {
            "name": "baseCpm",
            "baseName": "baseCpm",
            "type": "number",
            "format": "double"
        },
        {
            "name": "minCpm",
            "baseName": "minCpm",
            "type": "number",
            "format": "double"
        },
        {
            "name": "maxCpm",
            "baseName": "maxCpm",
            "type": "number",
            "format": "double"
        }    ];

    static getAttributeTypeMap() {
        return V3RTBCampaign.attributeTypeMap;
    }

    public constructor() {
    }
}

